<div class="mb-4 mt-4">
    <label for="nomeOrPassaporte" class="form-label required">Data de nascimento</label>
    <div class="row justify-content-center align-items-center">
        <div class="col-12 col-md-4">
            <input class="date-4" type="text" placeholder="DD" maxlength="2" onlyNumbers [(ngModel)]="dia">
        </div>
        <div class="col-12 col-md-4">

            <input class="date-4" type="text" placeholder="MM" maxlength="2" onlyNumbers [(ngModel)]="mes">
        </div>
        <div class="col-12 col-md-4">
            <input class="date-4" type="text" placeholder="YYYY" maxlength="4" onlyNumbers [(ngModel)]="ano">
        </div>
    </div>
</div>